













































import {defineComponent} from '@vue/composition-api'
import {useGetters, useMutations, useState} from 'vuex-composition-helpers'

import linkDirective from '@/shared/directives/link-directive'

import breakpointService from '@/shared/services/breakpoint-service'

import {Breakpoint} from '@/shared/models/breakpoint-type'

import IconLinkAtom from '@/shared/components/atoms/IconLinkAtom.vue'
import ImageRatioMolecule from '@/shared/components/molecules/ImageRatioMolecule.vue'
import IntroComponent from '../shared/IntroComponent.vue'
import HeadingAtom from '@/shared/components/atoms/HeadingAtom.vue'
import NavigationComponent from '../shared/NavigationComponent.vue'
import {ISlide} from '../../models/slide'

export default defineComponent({
  name: 'MultipleSlider',
  components: {
    IconLinkAtom,
    ImageRatioMolecule,
    IntroComponent,
    HeadingAtom,
    NavigationComponent
  },
  directives: {
    linkDirective
  },
  methods: {
    containsLink(slide: ISlide): Boolean {
      return Boolean(slide?.link?.trim())
    }
  },
  setup: () => {
    const {currentIndex, transition} = useState(['currentIndex', 'transition'])
    const {setSlidesPerView} = useMutations(['setSlidesPerView'])
    const {showNavigation, multipleSlides, imageFallback} = useGetters(['showNavigation', 'multipleSlides', 'imageFallback'])

        function slidesPerView(): number {
            const breakpoint: Breakpoint = breakpointService.currentBreakpoint
            
            switch (breakpoint) {
                case Breakpoint.Mobile:
                    return 1
                case Breakpoint.TabletPortrait:
                case Breakpoint.TabletLandscape:
                    return 2
                default:
                    return 3
            }
        }

        setSlidesPerView(slidesPerView())

        const resolveUrl = (url: string): string => {
            if (!url) {
                return '';
            }
            return url.startsWith('http')
                ? url
                : `${window.location.origin}${url}`;
        };

        const trackSlideClick = (slide: ISlide) => {
            if (typeof window !== "undefined" && (window as any).dataLayer) {
                const clickUrl = resolveUrl(slide.link || '');

                const studyNameElement = document.querySelector('.vuw-h1-alt-2.vuw-full-width');
                const studyName = studyNameElement ? studyNameElement.textContent?.trim() || '' : '';

                const eventData: Record<string, any> = {
                    event: 'multiple_slider',
                    click_url: clickUrl,
                    click_text: slide.title || ''
                };

                if (studyName) {
                    eventData.study_name = studyName;
                }

                (window as any).dataLayer.push(eventData);
            }
        };

        return {
            currentIndex,
            transition,
            showNavigation,
            multipleSlides,
            imageFallback,
            trackSlideClick
        }
    }
})
